import { InfoBox, Button } from '../Components'

const ErrorPage = ({ errorMessage }: { errorMessage?: string }) => (
  <InfoBox title='Oops' subtitle={errorMessage || 'Something went wrong'}>
    <Button href='/scan'>Take me home</Button>
  </InfoBox>
);

export default ErrorPage;
